import {Component, Input, ViewChild} from "@angular/core";
import {Leasing} from "../../../../../../../../../../server/src/base/entities/leasing/Leasing";
import {IContext} from "../../userReservation/userReservationEdit";
import {ModalTemplate, SuiModalService, TemplateModalConfig} from "ng2-semantic-ui";

@Component({
    selector: 'leasing-details',
    styleUrls: ['./leasingDetails.scss'],
    templateUrl: './leasingDetails.html'
})
export class LeasingDetailsComponent {
    @Input() leasing:Leasing;
    @ViewChild('modalTemplate') modalTemplate:ModalTemplate<IContext, string, string>;
    private config:TemplateModalConfig<IContext, string, string>;

    constructor(public modalService:SuiModalService){

    }

    ngOnInit(){
        this.config = new TemplateModalConfig<IContext, string, string>(this.modalTemplate);
        this.config.closeResult = "closed!";
        this.config.isClosable = false;
        this.config.context = { data: "" };
    }

    public Open() {
        this.modalService.open(this.config);
    }
}



// WEBPACK FOOTER //
// C:/Users/Benoit/WebstormProjects/schiltz/client/src/app/presentation/components/garage/leasing/presentation/leasing/leasingDetails/leasingDetails.ts